export const choosing_supplement = [
    {
        Xpos_text: 25,
        Ypos_text: 100,
        page_eng: 15,
        page_thai: 14,
        info: [
            {sp: 'Akkermansia muciniphila', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Bifidobacterium bifidum', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Bifidobacterium breve', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Bifidobacterium lactis', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Bifidobacterium longum', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus acidophilus', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus gasseri', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus helveticus', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus paracasei', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus plantarum', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus reuteri', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus rhamnosus', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Streptococcus thermophilus', less: ['Deficient', 'Slightly Deficient']},
        ]
    }
]

export const supplement_bacteria_map = {

    'BIO-A01': {
      'Bifidobacterium bifidum': 100,
      'Lactobacillus paracasei': 1000,
      'Lactobacillus reuteri': 100,
      'Lactobacillus rhamnosus': 100,
      'Lactobacillus acidophilus': 10
    },

    'BIO-G02': {
      'Akkermansia muciniphila': 100,
      'Lactobacillus helveticus': 1000,
      'Lactobacillus plantarum': 100,
      'Streptococcus thermophilus': 1000
    },

    'BIO-GA03': {
        'Bifidobacterium breve': 1000,
        'Lactobacillus paracasei': 100,
        'Lactobacillus rhamnosus': 1000,
        'Bifidobacterium bifidum': 10
    },

    'BIO-I04': {
        'Bifidobacterium bifidum': 1000,
        'Bifidobacterium breve': 100,
        'Bifidobacterium lactis': 100,
        'Bifidobacterium longum': 100,
        'Lactobacillus gasseri': 100,
    },

    'BIO-M05': {
        'Lactobacillus gasseri': 1000,
        'Lactobacillus helveticus': 100,
        'Lactobacillus plantarum': 1000,
        'Streptococcus thermophilus': 100
    },

    'BIO-MS06': {
        'Bifidobacterium lactis': 1000,
        'Bifidobacterium longum': 1000,
        'Lactobacillus acidophilus': 100,
        'Bifidobacterium breve': 10,
        'Lactobacillus paracasei': 10
    },

    'BIO-P07': {
        'Lactobacillus acidophilus': 1000,
        'Lactobacillus reuteri': 1000,
        'Bifidobacterium longum': 10,
        'Lactobacillus gasseri': 10
    },
};



export const supplement_images_eng = {

    'BIO-A01': {
        image_name: 'BIO-A01s',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-G02': {
        image_name: 'BIO-G02s',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-GA03': {
        image_name: 'BIO-GA03s',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-I04': {
        image_name: 'BIO-I04s',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-M05': {
        image_name: 'BIO-M05s',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-MS06': {
        image_name: 'BIO-MS06s',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-P07': {
        image_name: 'BIO-P07s',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

};



export const supplement_images_thai = {
    'BIO-A01': {
        image_name: 'BIO-A01_thais',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-G02': {
        image_name: 'BIO-G02_thais',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-GA03': {
        image_name: 'BIO-GA03_thais',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-I04': {
        image_name: 'BIO-I04_thais',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-M05': {
        image_name: 'BIO-M05_thais',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-MS06': {
        image_name: 'BIO-MS06_thais',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

    'BIO-P07': {
        image_name: 'BIO-P07_thais',
        page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },

};

// Function to calculate age from date of birth
export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return 0;
  let birthDate;
  if (typeof dateOfBirth === 'string') {
    const dateParts = dateOfBirth.split('/');
    if (dateParts.length === 3) {
      const part1 = parseInt(dateParts[0], 10);
      const part2 = parseInt(dateParts[1], 10);
      const year = parseInt(dateParts[2], 10);
      let month, day;
      if (part1 > 12) { // Assume DD/MM/YYYY if first part > 12
        day = part1;
        month = part2;
      } else if (part2 > 12) { // Assume MM/DD/YYYY if second part > 12
        month = part1;
        day = part2;
      } else { // Ambiguous, default to MM/DD/YYYY
        month = part1;
        day = part2;
      }
      birthDate = new Date(year, month - 1, day);
    } else {
      return 0;
    }
  } else if (dateOfBirth instanceof Date) {
    birthDate = dateOfBirth;
  } else {
    return 0;
  }
  if (isNaN(birthDate.getTime())) {
    return 0;
  }
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

// Function to get the final supplement list (BioGrace not available for QPT panel)
export const getFinalSupplementList = (selectedSupplements, dateOfBirth) => {
  return selectedSupplements;
};